import React from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'

import { poListColumns } from './data'
import { ProcurementContainer, ProcurementBody } from '../styled'
import { purchaseOrderDetailPath, purchaseOrderEditPath } from 'routes'
import { fetchPo } from 'ducks/purchaseOrder'
  import { 
    MainBodyContent, 
    SearchList2,
    TablePagination 
  } from 'components'

const PurchaseOrder = (props) => {
  const { 
    listPo, 
    listPoLoading,
    valueForm 
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(()=>{
    props.fetchPo({page:1,size:pageSize})
  },[])

  return (
    <MainBodyContent headerTitle='Purchase Order'>
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList2 pageSize={pageSize} placeholder='Doc No., SAP Doc No., Title, Requester, Activity' fetchAPI={props.fetchPo} formSearchName='formSearchPO' filterDate filterStatus filterCompany isPOSearch/>
          <ReactTable
            data={Object.keys(listPo).length>0?listPo.data:[]}
            columns={poListColumns}
            loading={listPoLoading}
            defaultPageSize={userPageSize}
            noDataText='No Purchase Order data'
            previousText={<Icon name='arrow alternate circle left'/>}
            nextText={<Icon name='arrow alternate circle right'/>}
            className='poList'

            PaginationComponent={TablePagination}
            pages={Object.keys(listPo).length>0?listPo.totalPage:0}
            currentPage={Object.keys(listPo).length>0?listPo.page:0}
            onPageChange={(pageIndex) => {
              props.fetchPo({...valueForm,page:pageIndex+1,size:pageSize})
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              setPageSize(pageSize)
              localStorage.setItem('userPageSize', pageSize)
              props.fetchPo({...valueForm,page:pageIndex+1,size:pageSize})
            }}

            getTdProps={(state, rowInfo, column) => {
              return {
                onClick: (e, handleOriginal) => {
                  if (rowInfo && column && column.Header !== '') {
                    if ([0, 5].indexOf(rowInfo.original.status) >= 0) {
                      window.open(purchaseOrderEditPath(rowInfo.original.id))
                    } else {
                      window.open(purchaseOrderDetailPath(rowInfo.original.id))
                    }
                  }
                  if (handleOriginal) {
                    handleOriginal()
                  }
                }
              }
            }}
          />
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  listPo: state.po.listPo.data,
  listPoLoading: state.po.listPo.loading,
  valueForm: getFormValues('formSearchPO')(state)
})

const mapDispatchToProps = {
  fetchPo
}

const contForm = reduxForm({
  form: 'formSearchPO',
  enableReinitialize: true,
})(PurchaseOrder)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
